export default {"src":"/_next/static/media/settings.86b62af2.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};